<template>
  <!-- Hero Section with Image Slider -->
    <section class="relative h-[80vh] bg-gradient-to-br from-blue-100 via-sky-200 to-white overflow-hidden">
    <!-- Background Image Slider -->
    <div class="absolute inset-0" @mouseenter="stopAutoPlay" @mouseleave="startAutoPlay">
        <div class="relative w-full h-full">
            <!-- Dynamic Slides -->
            <div v-for="(slide, index) in slides" :key="index"
                 class="absolute inset-0 transition-opacity duration-1000" 
                 :class="currentSlide === index ? 'opacity-100' : 'opacity-0'">
                <img :src="slide.image" :alt="slide.alt" 
                     class="w-full h-full object-cover brightness-110 contrast-110">
                <div class="absolute inset-0" :class="slide.overlay"></div>
            </div>
        
        <div class="absolute inset-0 opacity-20">
            <div class="w-full h-full" style="background-image: radial-gradient(circle, rgba(255,255,255,0.1) 1px, transparent 1px); background-size: 20px 20px;"></div>
        </div>
        
        <!-- Slide Navigation Dots -->
        <div class="absolute bottom-20 left-1/2 transform -translate-x-1/2 flex space-x-3">
            <button 
              v-for="(slide, index) in slides" 
              :key="index"
              @click="goToSlide(index)"
              class="w-3 h-3 rounded-full transition-colors"
              :class="currentSlide === index ? 'bg-gray-700/80' : 'bg-gray-600/40 hover:bg-gray-600/60'"
            ></button>
        </div>
        
        <!-- Navigation Arrows -->
        <button 
          @click="prevSlide"
          class="absolute left-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-gray-800/20 hover:bg-gray-800/40 backdrop-blur-sm rounded-full flex items-center justify-center transition-all duration-300 group"
        >
          <svg class="w-6 h-6 text-gray-700 group-hover:scale-110 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
          </svg>
        </button>
        
        <button 
          @click="nextSlide"
          class="absolute right-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-gray-800/20 hover:bg-gray-800/40 backdrop-blur-sm rounded-full flex items-center justify-center transition-all duration-300 group"
        >
          <svg class="w-6 h-6 text-gray-700 group-hover:scale-110 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
          </svg>
        </button>
        
        </div>
    </div>

    <!-- Content -->
    <div class="relative z-10 h-full flex items-center">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div class="max-w-3xl">
  <h1 class="text-5xl lg:text-6xl font-bold text-gray-800 leading-tight mb-8">
  <span class="bg-gradient-to-r from-blue-600 to-cyan-600 bg-clip-text text-transparent">ระบบ KM สำหรับองค์กร</span>
  <span class="block mt-2 lg:mt-3">พัฒนาทักษะพนักงานอย่างเป็นระบบ</span>
  </h1>
      <p class="text-xl lg:text-2xl text-gray-700 mb-10 leading-relaxed">
  แพลตฟอร์ม In-House Training ที่ช่วยให้การอบรมพนักงานเป็นเรื่องง่าย
  สร้างคอร์สได้รวดเร็ว จัดการผู้เรียนยืดหยุ่น ติดตามผลได้ครบ และวัด ROI ของการฝึกอบรมได้ชัดเจน
      </p>
            <div class="flex flex-col sm:flex-row gap-6">
      <button @click="openSchedule('trial', { source: 'hero' })" class="bg-gradient-to-r from-blue-600 to-cyan-600 text-white px-10 py-4 rounded-xl font-bold text-lg hover:from-blue-700 hover:to-cyan-700 transition-all duration-300 transform hover:scale-105 shadow-xl">
        เริ่มใช้ฟรี
      </button>
      <button @click="openSchedule('demo', { source: 'hero' })" class="border-2 border-gray-600 text-gray-700 px-10 py-4 rounded-xl font-semibold text-lg hover:bg-gray-100 transition-all duration-300">
        นัดสาธิต
      </button>
            </div>
            
            <!-- Trust Indicators -->
            <div class="mt-12 flex flex-wrap items-center gap-6 text-gray-600">
            <div class="flex items-center space-x-2">
                <svg class="w-5 h-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
                </svg>
                <div>
                <span class="text-sm font-medium">ได้รับความไว้วางใจจากหลากหลายองค์กร</span>
                <div class="text-xs text-gray-500">ตั้งแต่ธุรกิจขนาดเล็กไปจนถึงบริษัทระดับองค์กร</div>
                </div>
            </div>
            <div class="flex items-center space-x-2">
                <svg class="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
                <div>
                <span class="text-sm font-medium">พร้อมให้บริการ 99.9% (SLA)</span>
                <div class="text-xs text-gray-500">มีการชดเชยตามเงื่อนไข</div>
                </div>
            </div>
            <div class="flex items-center space-x-2">
                <svg class="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"/>
                </svg>
                <div>
                <span class="text-sm font-medium">พร้อมใช้งานภายใน 24 ชั่วโมง</span>
                <div class="text-xs text-gray-500">รวมบริการย้ายข้อมูลครบถ้วน</div>
                </div>
            </div>
            <div class="flex items-center space-x-2">
                <svg class="w-5 h-5 text-cyan-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192L5.636 18.364M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z"/>
                </svg>
                <div>
                <span class="text-sm font-medium">ดูแล 24/7</span>
                <div class="text-xs text-gray-500">รองรับทั้งไทยและอังกฤษ</div>
                </div>
            </div>
            </div>
        </div>
        </div>
    </div>

    <!-- Scroll Indicator -->
    <div class="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <svg class="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 14l-7 7m0 0l-7-7m7 7V3"/>
        </svg>
    </div>
    </section>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { useScheduleModal } from '~/composables/useScheduleModal'
const { openSchedule } = useScheduleModal()

// Slides data array
const slides = ref([
  {
    image: 'https://vue-project.sgp1.digitaloceanspaces.com/2025/08/1755248133106.jpg',
    alt: 'ออฟฟิศสมัยใหม่',
    overlay: 'bg-gradient-to-r from-blue-100/80 via-sky-200/75 to-white/85'
  },
  {
    image: 'https://vue-project.sgp1.digitaloceanspaces.com/2025/08/1755248132734.jpg',
    alt: 'พื้นที่ทำงานสายเทคโนโลยี',
    overlay: 'bg-gradient-to-r from-sky-100/80 via-blue-200/75 to-cyan-100/85'
  },
  {
    image: 'https://vue-project.sgp1.digitaloceanspaces.com/2025/08/1755248132245.jpg',
    alt: 'การเรียนรู้แบบดิจิทัล',
    overlay: 'bg-gradient-to-r from-cyan-100/80 via-sky-200/75 to-blue-100/85'
  }
])

// Reactive state
const currentSlide = ref(0)
const totalSlides = slides.value.length
let slideInterval = null

// Methods
const goToSlide = (index) => {
  currentSlide.value = index
}

const nextSlide = () => {
  currentSlide.value = (currentSlide.value + 1) % totalSlides
}

const prevSlide = () => {
  currentSlide.value = currentSlide.value === 0 ? totalSlides - 1 : currentSlide.value - 1
}

// Auto-play functionality
const startAutoPlay = () => {
  slideInterval = setInterval(() => {
    nextSlide()
  }, 5000) // เปลี่ยนทุก 5 วินาที
}

const stopAutoPlay = () => {
  if (slideInterval) {
    clearInterval(slideInterval)
    slideInterval = null
  }
}

// Lifecycle hooks
onMounted(() => {
  startAutoPlay()
})

onUnmounted(() => {
  stopAutoPlay()
})

// Keyboard navigation
const handleKeyPress = (event) => {
  if (event.key === 'ArrowLeft') {
    prevSlide()
  } else if (event.key === 'ArrowRight') {
    nextSlide()
  }
}

onMounted(() => {
  document.addEventListener('keydown', handleKeyPress)
})

onUnmounted(() => {
  document.removeEventListener('keydown', handleKeyPress)
})
</script>

<style scoped>
/* Any component-specific styles can be added here */
</style>
